import { useLinked } from "@linked/react/lib";
import { makeStyles, styled } from "@material-ui/core";
import { Button, Input, PopupDialog, div } from "lqx-react/lib";
import React from "react";
import { TargetFieldCard } from "../../../api/targetFieldCard";
import { DigiSelect } from "../../../components/select";
import { ErrorHighligter } from "../../../shared";

export const StaticSelectionPopup = ({ onStaticSelectionApply, onClose, inBlockStaticFields }
  : { onStaticSelectionApply: any, onClose: any, inBlockStaticFields: TargetFieldCard[] }) => {
  const $field = useLinked({ id: null, name: '' }).check(x => Boolean(x.id));
  const $inputLinked = useLinked('');
  const classes = makeErrorHighlighterStyles();
  return (
    <>
      <MapSourceFieldsPopupDialog
        title=''
        actions={
          <>
            <Button disabled={Boolean($field.error)} onClick={() => onStaticSelectionApply($field.value.name, $inputLinked.value, $field.value.id)}>
              Apply
            </Button>
          </>
        }
        maxWidth='xs'
        hideTitle={true}
        onClose={onClose}
      >

        <InBlockFieldLabel>Field</InBlockFieldLabel>
        <ErrorHighligter error={$field.error} classes={classes}>
          <InBlockFieldSelect id="id" label="name" $value={$field} options={inBlockStaticFields}></InBlockFieldSelect>
        </ErrorHighligter>
        <Input $value={$inputLinked} />
      </MapSourceFieldsPopupDialog>
    </>
  );
};

const InBlockFieldLabel = div({
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '13px',
  padding: '4px',
  marginTop: '5px',
  color: '#4197d6'
});

const InBlockFieldSelect = styled(DigiSelect)({
  width: '250px',
  borderRadius: '4px',
  '& .MuiSelect-root': {
    borderRadius: '4px',
  },
  '& .MuiSelect-icon': {
    top: 'calc(50% - 9px)'
  },
});

const MapSourceFieldsPopupDialog = styled(PopupDialog)({
  '& .MuiDialog-paperFullWidth': {
    width: '350px',
  }
});

const makeErrorHighlighterStyles = makeStyles({
  root: {
    border: '2px solid #ffdf71 !important',
    paddingLeft: '5px',
    borderRadius: '10px',
    paddingRight: '5px',
    height: '42px',
    '& [class*="-control"]': {
      border: 'none !important'
    }
  },
});
